/**
 * @file Form constants for UserWelcome organization creation flow
 * @description Centralizes form field names, validation rules, and test identifiers
 */

/**
 * Form field names for react-hook-form
 * @constant {Object}
 */
export const FORM_FIELDS = {
    CONTACT_FIRST_NAME: 'contactFirstName',
    CONTACT_LAST_NAME: 'contactLastName',
    ORGANISATION_NAME: 'organisationName',
    ORGANISATION_CUTTING_TECH_POWER: 'organisationCuttingTechnologyPower',
    ORGANISATION_COUNTRY: 'organisationCountry',
    ORGANISATION_UNITS: 'organisationUnits',
    ORGANISATION_LANGUAGE: 'organisationLanguage',
    ORGANISATION_CURRENCY_CODE: 'organisationCurrencyCode',
    ORGANISATION_LOCALE: 'organisationLocale',
    ORGANISATION_VOUCHER_CODE: 'organisationVoucherCode',
}

/**
 * Default form values
 * @constant {Object}
 */
export const DEFAULT_FORM_VALUES = {
    [FORM_FIELDS.CONTACT_FIRST_NAME]: '',
    [FORM_FIELDS.CONTACT_LAST_NAME]: '',
    [FORM_FIELDS.ORGANISATION_NAME]: '',
    [FORM_FIELDS.ORGANISATION_CUTTING_TECH_POWER]: '',
    [FORM_FIELDS.ORGANISATION_COUNTRY]: '',
    [FORM_FIELDS.ORGANISATION_UNITS]: '',
    [FORM_FIELDS.ORGANISATION_LANGUAGE]: '',
    [FORM_FIELDS.ORGANISATION_CURRENCY_CODE]: '',
    [FORM_FIELDS.ORGANISATION_LOCALE]: '',
    [FORM_FIELDS.ORGANISATION_VOUCHER_CODE]: '',
}

/**
 * Test identifiers for form elements
 * @constant {Object}
 */
export const TEST_IDS = {
    FIRST_NAME: 'user-welcome-first-name',
    LAST_NAME: 'user-welcome-last-name',
    ORGANISATION_NAME: 'user-welcome-organisation-name',
    CUTTING_TECH_POWER: 'user-welcome-cutting-technology-power',
    CUTTING_TECH_POWER_LABEL: 'user-welcome-cutting-technology-power-label',
    COUNTRY_INPUT: 'user-welcome-country-input',
    COUNTRY_LABEL: 'user-welcome-country-label',
    CURRENCY_INPUT: 'user-welcome-currency-input',
    CURRENCY_LABEL: 'user-welcome-currency-label',
    CURRENCY_PREVIEW: 'user-welcome-currency-preview',
    CURRENCY_PREVIEW_LABEL: 'user-welcome-currency-preview-label',
    VOUCHER_CODE: 'user-welcome-voucher-code',
}

/**
 * Debounce delays in milliseconds
 * @constant {Object}
 */
export const DEBOUNCE_DELAYS = {
    COUNTRY_CHANGE: 500,
    VOUCHER_VALIDATION: 800,
}

/**
 * Unit system options
 * @constant {Array<{name: string, value: string}>}
 */
export const UNIT_SYSTEMS = {
    METRIC: 'metric',
    IMPERIAL: 'imperial',
}

/**
 * Default units based on country
 * @param {string} countryAlpha2 - ISO 3166-1 alpha-2 country code
 * @returns {string} Unit system ('metric' or 'imperial')
 */
export const getDefaultUnits = (countryAlpha2) => {
    return countryAlpha2 === 'US' ? UNIT_SYSTEMS.IMPERIAL : UNIT_SYSTEMS.METRIC
}

/**
 * Technical styling labels for the form layout
 * @constant {Object}
 */
export const TECHNICAL_LABELS = {
    DRAWING_REFERENCE: 'TT WELCOME: CREATE-ORG-001 | SCALE: 1:1 | REV: A',
    SECTION_ACCOUNT: 'Account details',
    SECTION_SETTINGS: 'Default settings',
    HEADER_SETUP: 'ORGANISATION SETUP',
    HEADER_WELCOME: 'WELCOME',
}
